// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once user editing uses an sp app.
import { useEventListener } from "@vueuse/core";
import { settleMount } from "#ce/framework/mount-ready";

const initialized = new WeakSet();

/**
 * Binds QA membership visibility to role controls within `root`, waiting for each role control to mount.
 *
 * @param {ParentNode} root
 * @returns {Promise<() => void>} A disposer that removes role listeners and permits reinitialization.
 */
export async function initializeQARoleMembership(root) {
  const disposers = [];

  for (const role of root?.querySelectorAll('[data-behaviour~="qa-role-membership"]') || []) {
    if (initialized.has(role)) {
      continue;
    }

    initialized.add(role);

    if (!(await settleMount(role)) || !role.isConnected) {
      initialized.delete(role);

      continue;
    }

    const members = role.closest("form")?.querySelector(role.dataset.qaTarget);

    if (!members) {
      initialized.delete(role);

      continue;
    }

    function updateQATeamMembers() {
      const selected = role.items.find((item) => String(item.value) === String(role.value));
      const author = String(selected?.dataset?.contentAuthor) === "true";

      members.style.display = author ? "" : "none";

      if (!author) {
        members.querySelectorAll('input[type="checkbox"]').forEach(function clearMembership(input) {
          input.checked = false;
        });
      }
    }

    const stopRoleListener = useEventListener(role, ["change", "input"], updateQATeamMembers);
    updateQATeamMembers();

    function disposeRole() {
      stopRoleListener();
      initialized.delete(role);
    }

    disposers.push(disposeRole);
  }

  return function disposeQARoleMembership() {
    disposers.splice(0).forEach((dispose) => dispose());
  };
}
